<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>noise_control_off</mat-icon>
        <div>SBCCV Play</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">

        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">

        <a mat-button (click)="openDialog(null)" matTooltip='Novo Doc' style="width:60px;">
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>
      </div>

    </mat-toolbar>
  </mat-card>


  <mat-card>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="position" matSortDirection='asc'
      matSortDisableClear=true style='height: calc(100vh - 180px); overflow: auto;'>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon class="icon-dot">noise_control_off</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- Image Column -->
      <ng-container matColumnDef="image">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Imagem </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <img style="width: 150px; margin: 10px;" [src]=element.src>
        </mat-cell>
      </ng-container>

      <!-- Title Column -->
      <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Título </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div style="color:rgba(0,0,0, .7)">
            <div>
              <b>{{ element.title }}</b>
            </div>
            <div>
              <i>Dt. Vídeo: {{element.date.toDate() | date: "dd/MM/yyyy"}} &bull; Entrada: {{element.dateIn.toDate() |
                date: "dd/MM/yyyy"}} &bull; Saída: {{element.dateOut.toDate() | date: "dd/MM/yyyy"}}</i>
            </div>
          </div>

        </mat-cell>
      </ng-container>

      <!-- Tasting Column -->
      <ng-container matColumnDef="tasting">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Degusta </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf="element.tasting">Sim</span>
          <span *ngIf="!element.tasting">Não</span>
        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' matTooltip='Editar' style="background-color: whitesmoke;">
            <mat-icon class='icon-info'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='delete(element)' matTooltip='Apagar' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete' style="font-size:1.5em;">delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>